(function ($) {
	$(document).ready(function () {

		$(".team-modal").appendTo("body");

	});
})(jQuery);
